var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ins',{staticClass:"adsbygoogle",staticStyle:{"display":"block","width":"100%","height":"100%"},attrs:{"data-ad-client":"ca-pub-9068539038073295","data-ad-slot":"9123470530","data-ad-format":"fluid","data-ad-layout-key":"-fb+5w+4e-db+86"}})
}
var staticRenderFns = []

export { render, staticRenderFns }